<div class="py-16">
  <div class="flex bg-slate-900 rounded-lg shadow-lg overflow-hidden mx-auto max-w-sm lg:max-w-4xl">
    <div class="hidden lg:block lg:w-1/2 bg-cover" [style.background-image]="'url(' + backgroundImage + ')'">
      <ng-content select="[halfpage-left]"></ng-content>
    </div>
    <div class="w-full p-8 lg:w-1/2">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>